import React from 'react';
import styles from './Tag.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Tag = (props) => {
  const tagColor = classNames({
    [styles.primary]: props.color === 'primary',
    [styles.secondary]: props.color === 'secondary'
  });

  return (
    <div className={styles.actions}>
      <div
        className={props.anim ? classNames(tagColor, styles.anim) : tagColor}
      >
        {props.name}
      </div>
    </div>
  );
};
Tag.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  anim: PropTypes.bool
};
export default Tag;
